import useGetFeatures from './useGetFeatures'

export default useGetFeatures
